import React from "react";
import CourseDetailPage from "../components/Courses/Shared/CourseDetailPage";

const DataStructuresAlgorithms = () => {
  const courseData = {
    backLink: "/course/computer-science",
    heroTitle: "Data Structures & Algorithms",
    heroSubtitle: "Master the fundamental building blocks of efficient programming and problem-solving",
    heroImage: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=2072&q=80",
    introParagraphs: [
      "Data Structures and Algorithms form the backbone of computer science and software engineering. This essential course teaches you how to organize data efficiently and solve complex problems using proven algorithmic techniques. Mastery of these concepts is crucial for writing efficient, scalable software and excelling in technical interviews.",
      "You'll learn about fundamental data structures including arrays, linked lists, stacks, queues, trees, graphs, and hash tables. Each structure is accompanied by practical algorithms for insertion, deletion, searching, and traversal operations. The course emphasizes both theoretical understanding and practical implementation.",
      "Through hands-on coding exercises and real-world problem-solving scenarios, you'll develop the analytical thinking and programming skills needed to tackle complex computational challenges. This course prepares you for advanced computer science topics and technical interviews at top technology companies."
    ],
    learningOutcomes: [
      "Master fundamental data structures (arrays, lists, stacks, queues)",
      "Understand tree and graph data structures and their applications",
      "Learn essential sorting and searching algorithms",
      "Analyze algorithm time and space complexity (Big O notation)",
      "Implement dynamic programming solutions",
      "Solve problems using greedy algorithms and divide-and-conquer techniques",
      "Apply graph algorithms for pathfinding and network analysis",
      "Design efficient algorithms for real-world problems",
      "Prepare for technical interviews and coding challenges",
      "Develop problem-solving and analytical thinking skills"
    ],
    careerPaths: [
      {
        title: "Software Engineer",
        description: "Design and implement efficient software solutions using optimal algorithms and data structures.",
        color: "bg-gradient-to-r from-blue-500 to-purple-600"
      },
      {
        title: "Algorithm Engineer",
        description: "Develop and optimize algorithms for specific applications and performance requirements.",
        color: "bg-gradient-to-r from-green-500 to-teal-600"
      },
      {
        title: "Data Scientist",
        description: "Apply algorithmic thinking to analyze large datasets and extract meaningful insights.",
        color: "bg-gradient-to-r from-orange-500 to-red-600"
      },
      {
        title: "Research Scientist",
        description: "Conduct research in computer science and develop new algorithmic solutions.",
        color: "bg-gradient-to-r from-pink-500 to-rose-600"
      },
      {
        title: "Technical Interviewer",
        description: "Evaluate candidates' algorithmic thinking and problem-solving abilities.",
        color: "bg-gradient-to-r from-indigo-500 to-blue-600"
      },
      {
        title: "Competitive Programmer",
        description: "Participate in programming competitions and solve complex algorithmic challenges.",
        color: "bg-gradient-to-r from-purple-500 to-indigo-600"
      }
    ],
    prerequisites: "Programming Fundamentals or equivalent programming experience",
    duration: "16 weeks",
    level: "Intermediate to Advanced"
  };

  return <CourseDetailPage {...courseData} />;
};

export default DataStructuresAlgorithms;

